export default __webpack_public_path__ + "static/media/notFound.1d91afd4.svg";